const selesquad = ["deajace99@gmail.com", "se.legoff@gmail.com", "ilona@selego.co", "leopold@selego.co", "office@selego.co", "alan@exoqua.com", "gabrielalala97@gmail.com"];

// Users allowed to see the "Budgets Selego" / "Sales" pages in the sidebar
const budgetSelegoAccess = [
  "se.legoff@gmail.com", // Seb Le Goff
  "office@selego.co", // Nour El Sayed
  "deajace99@gmail.com", // Deborah Jace
  "alan@exoqua.com", // Alan Israel
  "ilona@selego.co", // Ilona Brosset
  "gabrielalala97@gmail.com", // Gabriela Lala
];

export const canAccessBudgetSelego = (user) => budgetSelegoAccess.includes(user?.email);

// Sales → Signature board. Wider than budgetSelegoAccess on purpose: the salespeople need the
// closing board without getting the Export and Budgets Selego pages that come with that list.
const salesAccess = [
  ...budgetSelegoAccess,
  "omar.zinelabidine.25@neoma-bs.com", // Omar Zinelabidine
  "nicolasgobinpro@gmail.com", // Nicolas Gobin
];
export const canAccessSales = (user) => salesAccess.includes(user?.email);

// Section Admin (overview, budgets Selego, plan, plan v2). Contenu sensible : coûts par personne,
// scénarios de sortie, trésorerie. Même liste que PLAN_ACCESS côté API.
const adminAccess = [
  "se.legoff@gmail.com", // Seb Le Goff
  "deajace99@gmail.com", // Deborah Jace
  "office@selego.co", // Nour El Sayed
  "alan@exoqua.com", // Alan Israel
  "gabrielalala97@gmail.com", // Gabriela Lala (pilotage Tirana)
];
export const canAccessAdmin = (user) => adminAccess.includes(user?.email);

export const hasAccess = ({ user, access }) => {
  if (!user || !user.role) return false;
  const roleHierarchy = {
    super_admin: ["super_admin", "admin", "user"],
    admin: ["admin", "user"],
    user: ["user"],
    client: ["client"],
  };

  const roles = roleHierarchy[user.role];
  return roles ? roles.includes(access) : false;
};

export const isInSelesquad = (user) => selesquad.includes(user.email);

// Check if user should have access to Management/Team features
// Available to: Selesquad members OR super_admin/admin (who are typically managers)
export const canAccessManagement = (user) => {
  if (!user) return false;
  if (isInSelesquad(user)) return true;
  if (user.role === "super_admin" || user.role === "admin") return true;
  // For regular users, we'd need to check if they have direct reports
  // For now, only Selesquad and admins can access
  return false;
};
